import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import promptSaga from './leads/saga'
import reportSaga from './reports/saga'
import vehicleExclusionsSaga from './vehicleExclusions/saga'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    promptSaga(),
    reportSaga(),
    vehicleExclusionsSaga(),
  ]);
}
